import { render, staticRenderFns } from "./getTypeView.vue?vue&type=template&id=f3a0dbb6&scoped=true"
import script from "./getTypeView.vue?vue&type=script&lang=js"
export * from "./getTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a0dbb6",
  null
  
)

export default component.exports